import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/AddInvoice';
import { useAuthValidation } from '../../utils/hooks';

const AddInvoicePage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default AddInvoicePage;
